const baseYearlyRenewalText = 'Planos de renovação anual automática.'

export const RENEWAL_TEXTS = {
  YEARLY_PROMOTIONAL: `${baseYearlyRenewalText} Pode ser cancelado durante os 30 dias de teste.`,
  YEARLY: `${baseYearlyRenewalText} Cancele ao final dos 12 meses se preferir não renovar.`,
  MONTHLY: 'Planos de renovação mensal automática. Cancele quando quiser.',
}
